<template>
  <ui-dropper v-model="modelElement.show">
    <template #head>
      <div class="flex items-center gap-1 w-full">
        <div class="flex flex-col self-stretch" @click.stop>
          <i class="flex-grow content-center hover:bg-gray-200 fas fa-angle-up cursor-pointer" @click="$emit('movedown')"/>
          <i class="flex-grow content-center hover:bg-gray-200 border-t fas fa-angle-down cursor-pointer" @click="$emit('moveup')"/>
        </div>

        <div @click.stop>
          <ui-select
            v-model="modelElement.type"
            class="min-w-[140px] max-w-[140px]"
            >
            <UiSelectOption
              v-for="available in availableElements.sort((a,b) => a.value.localeCompare(b.value))"
              :key="'available_'+available.value"
              :value="available.value.toLowerCase()"
              :text="available.value"
              />
          </ui-select>
        </div>

        <div class="break-all flex-grow line-clamp-5 text-xs leading-3" v-text="computedContent"/>

        <div class="flex items-baseline" @click.stop>
          <blog-button class="mt-1 -mb-1 ml-auto flex !py-0 pr-0 items-center overflow-auto relative">
            <span class="py-1 pr-2 hover:bg-white cursor-default" v-text="'New'"/>
            <i class="px-1 fas fa-angle-up border-x self-stretch content-center hover:bg-gray-200" @click="$emit('addabove')"/>
            <i class="px-1 fas fa-angle-down self-stretch content-center hover:bg-gray-200" @click="$emit('addbelow')"/>
          </blog-button>
          <i
            class="fas fa-trash cursor-pointer mr-2 px-2 py-1 text-sm text-red-600 hover:bg-red-100 rounded"
            @click="$emit('remove')"
            />
        </div>
      </div>
    </template>

    <component
      :is="'blog-content-'+(modelElement?.type ?? 'paragraph')"
      v-model:blog="modelBlog"
      :model-value="modelElement"
      @remove="$emit('remove')"
      />
  </ui-dropper>
</template>

<script setup lang="ts">
defineEmits(['remove','addbelow','addabove','moveup','movedown'])
const modelBlog = defineModel<Blog>('blog')
const modelElement = defineModel<BlogElement>('element',{
  default: {
    id: null,
    type: 'paragraph',
    content: '',
  },
})

const { locale } = useI18n()

onMounted(() => {
  if(!modelElement.value?.id){
    modelElement.value.id ??= Math.random().toString(36).substring(7)
  }
})

const computedContent = computed({
  get: () => {
    if(!modelElement.value) return ''

    return ((modelElement.value.editing_language ?? locale.value) != 'en')
      ? (modelElement?.value?.meta?.i18n?.[(modelElement.value?.editing_language ?? locale?.value) as SupportedLanguages]?.content
        ? modelElement?.value?.meta?.i18n?.[(modelElement.value?.editing_language ?? locale?.value) as SupportedLanguages]?.content
        : modelElement?.value?.content
      )
      : modelElement.value.content
  },
})
</script>
